import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SlidingPanelContent } from 'core/components';
import { TableLayoutType } from 'core/enums';
import { AgGridClientTableProvider } from 'core/states';
import { AttachedVendorQuoteListTable } from 'quotes/components';
import { useGetAttachedVendorQuotes } from 'quotes/hooks';
import { ICustomerQuote, IVendorQuoteListRequestPayload } from 'quotes/types';

import { columnDef } from './columns';
import { getRowClass } from './table';

interface IProps {
  quote: ICustomerQuote;
}

export const CustomerQuoteCosting = ({ quote }: IProps) => {
  const { t } = useTranslation();

  const payload: IVendorQuoteListRequestPayload = {
    filters: {
      associationTargetIds: {
        projectId: quote?.vendorProjectId,
        bomId: quote?.bomId,
        quoteId: quote?.id,
      },
    },
    pageSize: 20,
  };

  const {
    records,
    isLoading: isDataLoading,
    loadingPercentage,
    currentPage,
  } = useGetAttachedVendorQuotes(payload, { fetchAllPages: true });

  const columnDefs = useMemo(() => columnDef(), []);

  const defaultColDef = {
    minWidth: 100,
    width: 150,
    maxWidth: 300,
  };

  return (
    <AgGridClientTableProvider
      tableId="customerQuoteCostingTable"
      entityType="Quote"
      columnDefs={columnDefs}
      defaultColDef={defaultColDef}
      getRowId={(data: any) => data?.customId}
      data={records}
      isDataLoading={isDataLoading}
      loadingPercentage={loadingPercentage}
      dataCurrentPage={currentPage}
      getRowClass={({ data }) => getRowClass(data)}
      headerCheckbox={loadingPercentage === 100}
      layoutType={TableLayoutType.CUSTOMER_QUOTE_COSTING}
      hasLayoutActions
      hasManageFilters
    >
      <SlidingPanelContent title={t('titleCosting')}>
        <AttachedVendorQuoteListTable quote={quote} />
      </SlidingPanelContent>
    </AgGridClientTableProvider>
  );
};
